import { Button, Card, Col, ListGroup, ListGroupItem, Row } from "react-bootstrap"
import ConsumptionByApprenticeViewModel from '../../domain/models/report/ConsumptionByApprenticeViewModel'
import PaginatedSearchResult from "../../domain/util/PaginatedSearchResult"
import { StyledPagedSearchButtonList, CreatorCourseListComponentStyles } from "./styles"

interface ReportByApprenticeListComponentProps{
    consumptionByApprenticeListViewPaginatedSearch:PaginatedSearchResult<ConsumptionByApprenticeViewModel>    
    isLoading:boolean
    getConsumptionByApprentice :(pageNumber:number) => void    
}

const ReportByApprenticeListComponent = ({
    getConsumptionByApprentice,
    isLoading,
    consumptionByApprenticeListViewPaginatedSearch
}:ReportByApprenticeListComponentProps) => {    

    const {
        currentPage,
        totalPages,
        hasPrevious,
        hasNext,
        totalRecords,
        items
    } = consumptionByApprenticeListViewPaginatedSearch

    const RenderPageButtons = ():JSX.Element =>{

        const lowPageLimit = currentPage > 2? currentPage - 2 : (currentPage === 2? currentPage - 1 : 1)
        const highPageLimit = currentPage < totalPages - 2? currentPage + 2 : (currentPage === totalPages - 1? currentPage + 1 : totalPages)

        let buttons:JSX.Element[] = []


        for(let i=lowPageLimit; i < highPageLimit+1 ; i++){
            buttons.push(
                <ListGroup.Item>
                    <Button className={"my-auto "+(currentPage === i?"active":"")} onClick={() => getConsumptionByApprentice(i)}>
                        <p>{i}</p>
                    </Button>
                </ListGroup.Item>
            )
        }


        return(

            <StyledPagedSearchButtonList horizontal>
                <ListGroup.Item>
                    <Button disabled={!hasPrevious} onClick={() => getConsumptionByApprentice(1)}>
                        <i className="bi bi-chevron-bar-left"/>
                    </Button>
                </ListGroup.Item>
                {
                    currentPage > 5 &&
                    <ListGroup.Item>
                        <Button onClick={() => getConsumptionByApprentice(currentPage-5)}>
                            <p>
                                -5
                            </p>
                        </Button>
                    </ListGroup.Item>
                }
                <ListGroup.Item>
                    <Button disabled={!hasPrevious} onClick={() => getConsumptionByApprentice(currentPage-1)}>
                        <i className="bi bi-chevron-left"/>
                    </Button>
                </ListGroup.Item>
                {buttons}
                <ListGroup.Item>
                    <Button disabled={!hasNext} onClick={() => getConsumptionByApprentice(currentPage+1)}>
                        <i className="bi bi-chevron-right"/>
                    </Button>
                </ListGroup.Item>
                {
                    totalPages - currentPage > 4 &&
                    <ListGroup.Item>
                        <Button onClick={() => getConsumptionByApprentice(currentPage+5)}>
                            <p>
                                +5
                            </p>
                        </Button>
                    </ListGroup.Item>
                }

                
                <ListGroup.Item>
                    <Button disabled={!hasNext} onClick={() => getConsumptionByApprentice(totalPages)}>
                        <i className="bi bi-chevron-bar-right"/>
                    </Button>
                </ListGroup.Item>
            </StyledPagedSearchButtonList>)
    }

    const RenderLoadging = () : JSX.Element => {
        return (<>
            <Row className="mt-5 empty-result">
                <Col md="auto" className="ml-auto">
                    <img className="mr-3" src={"/img/student/home/woman-waiting.svg"} />
                </Col>
                <Col md="auto" className="my-auto mr-auto">
                    <Row>
                        <Col>
                            <h1>
                                Carregando dados...
                            </h1>
                        </Col>
                    </Row>
                    
                </Col>
            </Row>
        </>)
    }

    const RenderNoResult = () : JSX.Element => {
        return (<>
            <Row className="mt-5 empty-result">
                <Col md="auto" className="ml-auto">
                    <img className="mr-3" src={"/img/student/home/woman-waiting.svg"} />
                </Col>
                <Col md="auto" className="my-auto mr-auto">
                    <Row>
                        <Col>
                            <h1>Nenhum registro</h1>
                        </Col>
                    </Row>
                    
                </Col>
            </Row>
        </>)
    }

    const RenderResultTable = () : JSX.Element => {
        return (<>
            {   
                totalRecords >0?
                (<>     
                    <Row className="mt-2">
                        <Col md={4}>
                            <p className="pl-3">
                                Nome
                            </p>
                        </Col>
                        <Col md={4}>
                            <p>
                                Email
                            </p>
                        </Col>
                        <Col md={2}>
                            <p>
                                Cursos em andamento
                            </p>
                        </Col>                     
                        <Col md={2}>
                            <p>
                                Cursos finalizados
                            </p>
                        </Col>                                
                    </Row>
                    <Row className={isLoading?"d-none":""}>
                        <Col>
                            <ListGroup className="w-100 px-0">
                                {
                                    items.map(
                                        item =>{
                                            return(
                                                <ListGroupItem className="px-0 py-2">
                                                    <Card>
                                                        <Card.Body className="py-2">
                                                            <Row>
                                                                <Col md={4} className="my-auto">
                                                                    <p>{item.apprenticeName}</p>
                                                                </Col>
                                                                <Col md={4} className="my-auto">
                                                                    <p>{item.apprenticeEmail}</p>
                                                                </Col>                                                                        
                                                                <Col md={2} className="my-auto">
                                                                    <p>{item.qtyCourseInProgress}</p>
                                                                </Col>
                                                                <Col md={2} className="my-auto">
                                                                    <p>{item.qtyCourseDone}</p>
                                                                </Col>
                                                            </Row>
                                                        </Card.Body>
                                                    </Card>
                                                </ListGroupItem>
                                            )
                                        }
                                    )
                                }
                            </ListGroup>
                        </Col>
                    </Row>
                    {
                        consumptionByApprenticeListViewPaginatedSearch.totalPages > 1 &&
                        (
                        <Row className={isLoading?"d-none":""}>
                            <Col md={"auto"} className="mx-auto my-4">
                                <RenderPageButtons/>
                            </Col>
                        </Row>
                        )
                    }
                </>)
                : (RenderNoResult())
            }
        </>)
    }

    return(
        <CreatorCourseListComponentStyles className="ml-3"> 
            {isLoading 
                ? (RenderLoadging())
                : (RenderResultTable())
            }
        </CreatorCourseListComponentStyles>
    )
}

export default ReportByApprenticeListComponent;